import { Controller } from "@hotwired/stimulus"

// Copies plain text from a textarea/input target to the clipboard.
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const text = this.hasSourceTarget ? this.sourceTarget.value : ""
    if (!text) return

    const button = this.hasButtonTarget ? this.buttonTarget : this.element
    const original = button.textContent

    navigator.clipboard.writeText(text).then(() => {
      button.textContent = "Copied"
      window.setTimeout(() => {
        button.textContent = original
      }, 1500)
    }).catch(() => {
      button.textContent = "Copy failed"
      window.setTimeout(() => {
        button.textContent = original
      }, 1500)
    })
  }
}
